// extracted by mini-css-extract-plugin
export default {"fields":"VH1WYqDADbjFhntLmyhE"};